import type { ReactNode } from 'react';

export const symbol_hard_drive: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-260h680v-280H140v280Zm575.5-104.62q14.5-14.62 14.5-35.5 0-20.88-14.62-35.38-14.62-14.5-35.5-14.5-20.88 0-35.38 14.62-14.5 14.62-14.5 35.5 0 20.88 14.62 35.38 14.62 14.5 35.5 14.5 20.88 0 35.38-14.62ZM880-600h-85L695-700H265L165-600H80l142-142q8-8 19.28-13 11.28-5 23.72-5h430q12.44 0 23.72 5T738-742l142 142ZM140-200q-24.75 0-42.37-17.63Q80-235.25 80-260v-340h800v340q0 24.75-17.62 42.37Q844.75-200 820-200H140Z"
		/>
	</svg>
);
